import type { RouteObject } from 'react-router'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { OpportunitiesFeature } from '@/features/opportunities'
import { createOpportunitiesViewLoader } from './opportunity-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreateOpportunitiesRoutesOptions {
  opportunities: OpportunitiesFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the opportunities feature.
 */
export function createRoutes(
  options: CreateOpportunitiesRoutesOptions,
): RouteObject[] {
  return [
    {
      path: '/opportunities/:opportunityId?/*',
      loader: createOpportunitiesViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/opportunities/components/Opportunities/OpportunitiesContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
